import useAddressSheet from '../../hooks/useAddressSheet';

/*
 * Which of the camera's sheets is open, kept in the address
 * (/field?sheet=gallery | hub | pro | tasks), as the hub keeps ?peek=
 * (2026-10-21; docs/FIELD_AI_VISION_SPEC.md section 9). So the phone's own Back, the
 * Capacitor shell's Back and the camera's Back button close a sheet instead
 * of leaving the camera, and a link or a reload opens it again.
 *
 * One sheet at a time: opening a sheet pushes an entry; opening another while
 * one is open replaces it, so a single Back always returns to the camera.
 * Closing goes back through the entry the sheet pushed; a sheet that came
 * with the address (a link, a reload, an editor's Back) has none to go back
 * through, and the address simply loses its ?sheet.
 *
 * The rules are hooks/useAddressSheet.js's, which Home's tool sheet shares.
 */
export const FIELD_SHEETS = Object.freeze(['gallery', 'hub', 'pro', 'tasks']);

// The physical edge each sheet comes from (section 8: never mirrored). The
// Tasks sheet has none: its chip and the gallery's button open it (plan
// phase 6), never a swipe.
export const SHEET_AT_EDGE = Object.freeze({ right: 'gallery', left: 'hub', bottom: 'pro' });

// What the Tasks sheet is open on: ?mission=<id>, the card the assignment
// email's link names (/field?sheet=tasks&mission=<id>). Closing a sheet, or
// opening another, drops it.
const EXTRA = Object.freeze(['mission']);

export default function useFieldSheet() {
  const { sheet, values, open, close } = useAddressSheet('sheet', FIELD_SHEETS,
    { stateKey: 'fieldSheetPushed', extra: EXTRA });
  return { sheet, values, open, close };
}
